import * as React from 'react';
import { useEntrepreneurForm } from './useEntrepreneurForm';
import { Policy } from './Policy';
import { useForm } from 'react-hook-form';
import { Entrepreneur } from '../../../Model/Entrepreneur';
import FormField from '../../FormElements/Field';
import SubmitButton from '../../FormElements/SubmitButton';
import { phoneRegex } from '../../Validators/phoneRegex';

export const EntrepreneurForm = ({ isUpdate }: { isUpdate: boolean }) => {
  const { register, reset, handleSubmit, formState } = useForm<
    Partial<Entrepreneur> & { taxNumber: string; companyName: string }
  >();
  const { onSubmit, currentCompany, onClose, user, inProgress } = useEntrepreneurForm(isUpdate, register, reset);
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField name="taxNumber" label="Adótörzsszám (első 8 karakter):">
          <input
            id="taxNumber"
            {...register('taxNumber', {
              required: true,
              minLength: 8,
              maxLength: 8,
            })}
            minLength={8}
            maxLength={8}
            className="form-control"
            defaultValue={currentCompany?.taxNumber}
          />
        </FormField>
        <FormField name="companyName" label="Cég név:">
          <input
            type="text"
            id="companyName"
            minLength={2}
            required
            className="form-control"
            defaultValue={currentCompany?.name}
            {...register('companyName', {
              required: true,
              minLength: 2,
            })}
          />
        </FormField>
        <FormField name="name" label="Ügyvezető neve:">
          <input
            type="text"
            id="name"
            minLength={3}
            required
            className="form-control"
            defaultValue={user?.name}
            {...register('name', {
              required: true,
              minLength: 3,
            })}
          />
        </FormField>
        <FormField name="mobile" label="Ügyvezető mobil száma:">
          <input
            type="tel"
            id="mobile"
            className="form-control"
            defaultValue={user?.mobile}
            {...register('mobile', {
              pattern: {
                value: phoneRegex.regex,
                message: phoneRegex.message,
              },
            })}
            title={phoneRegex.message}
          />
          {formState.errors.mobile?.message && <span className="text-danger">{formState.errors.mobile?.message}</span>}
        </FormField>
        {!isUpdate && <Policy />}

        <div className="modal-footer mt-lg-5 d-flex justify-content-around">
          <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">
            Mégse
          </button>
          <SubmitButton text={'Mentés'} className={'btn btn-primary'} inProgress={inProgress} disabled={inProgress} />
        </div>
      </form>
    </div>
  );
};
